// The Fenix dataset plane has no GeoJSON serializer — it returns plain rows —
// so the conversion lives here, the way the flowmap builds its own geometry.

const toCoordinate = (value, limit) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    // Number() rather than parseFloat(): "60abc" is a broken cell, not 60.
    const parsed = Number(value);

    if (!Number.isFinite(parsed) || Math.abs(parsed) > limit) {
        return null;
    }

    return parsed;
};

const rowToFeature = (row) => {
    const { latitude, longitude, ...properties } = row;
    const lat = toCoordinate(latitude, 90);
    const lng = toCoordinate(longitude, 180);

    if (lat === null || lng === null) {
        return null;
    }

    return {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [lng, lat] },
        properties,
    };
};

export const rowsToGeoJson = (rows) => ({
    type: 'FeatureCollection',
    // A row we cannot place is a row we cannot plot. Dropping it keeps one bad
    // cell in the dataset from taking the whole map down.
    features: (rows || []).map(rowToFeature).filter(Boolean),
});
